import { FlexView, Row } from '@cuemath/comps';
import React from 'react';
import styled from 'styled-components';
import useLogic from './logic';
import Search from 'modules/list/new-search-bar';
import { Button, Separator, Text } from '@cuemath/web-comps';
import MappingFilters from '../components/mapping-filters';
import StudentDetails from '../components/student-details';
import CalendarPaginationButton from '../components/calendar-pagination-button';
import TeachersListingTable from '../components/teachers-listing-table';
import { AC_LED_MAPPING_FILTERS_KEY, MAPPER_TYPE } from 'constants/ac-led-mapping';
import PageButton from '../components/pagintation-buttons';
import { openModal } from 'actions/modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const ContentWrapper = styled(FlexView)``;

const AcLedMappingV2 = ({ actions }) => {
  const {
    handleGetStudentDetails,
    filters,
    handleChange,
    isSearchProcessing,
    handleSearchTeachers,
    showStudentDetails,
    studentDetails,
    handlePagination,
    viewNextPage,
    searchResult,
    handleOpenAcLedMappingResultFeedbackModal,
    showRejectRecommendedTeachersButton,
    handleNextTeacherPageButton,
    handlePrevTeacherPageButton,
    isNextTeacherPageButtonDisabled,
    isPrevTeacherPageButtonDisabled,
    showTeacherPageButtons,
    showDateTimeFilter,
    dateTimePreset,
    handleChangeDateTime,
    showAddSlotButton,
    handleAddNewSlot,
    handleRemoveSlot,
    mapperType,
  } = useLogic();

  const { timezone } = filters || {};
  const { prospectID, name, id, parentName, phone, grade, schoolBoard } =
    studentDetails ?? {};

  const { teachers, referralBannerMessage, zone } = searchResult ?? {};

  return (
    <ContentWrapper gap={24} gutter={16}>
      <FlexView flexDirection="row" justifyContent="flex-end">
        <Search
          showNewSearchBar={true}
          onSearch={handleGetStudentDetails}
          placeholder="Enter Prospect ID"
        />
      </FlexView>
      <Separator height={24} />
      {showStudentDetails && (
        <>
          <StudentDetails
            prospectID={prospectID}
            name={name}
            parentName={parentName}
            phone={phone}
            grade={grade}
            schoolBoard={schoolBoard}
            id={id}
          />
          <Separator height={24} />
        </>
      )}

      <Row alignItems="center" justifyContent="space-between">
        <MappingFilters
          key={`${prospectID}-mapping-filters`}
          filters={filters}
          timezone={timezone}
          showDateTimeFilter={showDateTimeFilter}
          handleChange={handleChange}
          handleSearchTeachers={handleSearchTeachers}
          isSearchProcessing={isSearchProcessing}
          configKey={AC_LED_MAPPING_FILTERS_KEY}
          dateTimePreset={dateTimePreset}
          handleChangeDateTime={handleChangeDateTime}
          showAddSlotButton={showAddSlotButton}
          handleAddNewSlot={handleAddNewSlot}
          handleRemoveSlot={handleRemoveSlot}
          mapperType={mapperType}
        />
      </Row>
      <Separator height={12} />
      {mapperType === MAPPER_TYPE.AC && (
        <>
          <FlexView flexDirection="row" justifyContent="space-between">
            {timezone && (
              <Row alignItems="center">
                <Text variant="body2">
                  All times shown below are in {timezone} timezone
                </Text>
              </Row>
            )}
            {showTeacherPageButtons && (
              <CalendarPaginationButton
                viewNextPage={viewNextPage}
                handlePagination={handlePagination}
              />
            )}
          </FlexView>

          <Separator height={12} />

          <TeachersListingTable
            teachers={teachers}
            viewNextPage={viewNextPage}
            isSearchProcessing={isSearchProcessing}
            referralBannerMessage={referralBannerMessage}
            timezone={timezone}
            prospectID={prospectID}
            zone={zone}
          />

          <Separator height={20} />
          {showTeacherPageButtons && (
            <FlexView flexDirection="row" justifyContent="space-between">
              <PageButton
                label="Previous Teacher"
                onClick={handlePrevTeacherPageButton}
                isDisabled={isPrevTeacherPageButtonDisabled()}
                isBusy={isSearchProcessing}
              />
              <PageButton
                label="Next Teacher"
                onClick={handleNextTeacherPageButton}
                isDisabled={isNextTeacherPageButtonDisabled()}
                isBusy={isSearchProcessing}
              />
            </FlexView>
          )}
          <Separator height={20} />
          <FlexView alignItems="flex-end">
            {!!showRejectRecommendedTeachersButton && (
              <Button
                label="Do not like the recommended teachers?"
                onClick={handleOpenAcLedMappingResultFeedbackModal}
                variant="tertiaryWithUnderline"
              />
            )}
          </FlexView>
        </>
      )}
    </ContentWrapper>
  );
};

export default connect(
  () => {},
  dispatch => ({
    actions: bindActionCreators(
      {
        openModal,
      },
      dispatch,
    ),
  }),
)(AcLedMappingV2);
